import type { FamilySummaryViewModel } from '@/models/family';

import type { QuickSearchResult } from './QuickSearch';

/** Two-letter initials from a family name ("Lakin Family" → "LF"). */
function familyInitials(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter((part) => part.length > 0);
  const initials = parts
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase();
  return initials.length > 0 ? initials : '—';
}

/**
 * Adapts a `FamilySummaryViewModel` to QuickSearch's row shape (PTV2-1232 #5).
 * `sublabel` carries the member count; the caller localises the "N members"
 * suffix, so this returns the raw count and the formatter lives in the shell.
 * Lives next to `toQuickSearchResult` for the same UI-contract reasons.
 */
export function toFamilyQuickSearchResult(
  family: FamilySummaryViewModel,
  memberSublabel: string,
): QuickSearchResult {
  const label =
    family.name.trim().length > 0 ? family.name : family.guid;
  return {
    id: family.guid,
    label,
    sublabel: memberSublabel,
    initials: familyInitials(family.name),
    href: `/families/${family.guid}`,
    sensitive: false,
  };
}
